import styled from 'styled-components';

export const CloseIcon = styled.img`
  width: 14px;
  align-self: flex-end;
  cursor: pointer;
`;

export const HeaderLine = styled.div`
  content: '';
  flex: 1;
  height: 1px;
  background-color: #4948ac;
  align-self: center;
`;

export const UserForm = styled.form`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
  justify-content: center;
`;

export const FormInputWrapper = styled.div`
  width: 100%;
`;

export const ActionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  width: 100%;
`;
